<template>
    <div v-if="this.$route.name !== 'home'" >
        <div class="row p-0 m-0">
            <div class="breadcrumb align-items-center">
                <div class="breadcrumb-back col text-start">
                    <span  @click="$router.go(-1)">
                        <img :src="`${publicPath}img/breadcrumbBack.gif`" width="12">
                    </span>
                </div>
                <div v-for="(crumb,key) in crumbs" :key="`crumb_${crumb.name}`"  class="breadcrumb-item col-md-auto">
                    <template v-if="(count > (key + 1))&&(!crumb.meta.notlinkable)">
                        <localized-link :to="crumb.path">{{ $t("nav."+crumb.name) }}</localized-link>
                    </template>
                    <template v-else>
                        {{ $t("nav."+crumb.name) }}
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            crumbs: this.$route.matched,
            publicPath: process.env.BASE_URL
        }
    },
    watch:{
        $route () {
            this.crumbs = this.$route.matched;
        }
    },
    computed: {
      count() {
        return this.$route.matched.length
      }
    }
}
</script>
